import DataSourcesPage from './dataSources.page';

export default DataSourcesPage;
